import { useCallback, useEffect, useRef, useState } from 'react';
import useFetch from 'hooks/useFetch';
import { useAppSelector } from 'store/hooks';
import * as actions from '../actions';
import { selectActiveTradingAccountId } from '../reducers/selectors';
const usePosition = (assetId, skipCall) => {
    const tradingAccountId = useAppSelector(selectActiveTradingAccountId);
    const cachedPosition = useAppSelector((state) => tradingAccountId ? state.invest.tradingAccountPositionsCache?.[tradingAccountId]?.[assetId] : undefined);
    const [positions, , loadingPositions, fetch] = useFetch();
    const [loading, setLoading] = useState(false);
    const suppressLoading = useRef(null);
    const refresh = useCallback(() => {
        if (suppressLoading.current === null) {
            suppressLoading.current = true;
        }
        else {
            setLoading(true);
        }
        if (tradingAccountId) {
            fetch(actions.getPositions({
                assetIds: [assetId],
                accountId: tradingAccountId,
                paging: { page: 1, perPage: 15 },
            }));
        }
    }, [assetId, tradingAccountId]);
    useEffect(() => {
        if (!skipCall) {
            refresh();
        }
    }, [refresh, skipCall]);
    useEffect(() => {
        if (!loadingPositions) {
            setLoading(false);
        }
    }, [loadingPositions]);
    return [positions ? positions.positions[0] ?? null : cachedPosition, loading, refresh];
};
export default usePosition;
